import Api from "../api";
let uri = "/api/ed/notificacion/plantilla";
let readUri = "/api/ed/notificaciones/plantillas";

export const getPlantillasNotificacion = () => {
  return Api.getInstance()
    .executeGetQuery(`${readUri}`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const createPlantillaNotificacion = (data) => {
  return Api.getInstance()
    .executeQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const editPlantillaNotificacion = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};
